<template>
    <div class="ActionItem">
        <h2>Add an Action Item <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh" /> <font-awesome-icon :icon="['fa', 'plus']" class="olive-green-text pointer" @click="ShowAddModal" /></h2>
        <form class="table-filters client-list">
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Start Due Date:</label>
                        <flat-pickr v-model="Filters.DueDateTime" class="form-control" :config="DateConfig"></flat-pickr>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>End Due Date:</label>
                        <flat-pickr v-model="Filters.EndDueDateTime" class="form-control" :config="DateConfig"></flat-pickr>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Category:</label>
                        <select class="form-control" v-model="Filters.Category">
                            <option value="All">All</option>
                            <option v-for="ActionItemCategory in ActionItemCategories" :value="ActionItemCategory.value">{{ ActionItemCategory.text }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </form>
        <vuetable :fields="ActionItemTable.Fields"
                  pagination-path=""
                  :api-mode="false"
                  class="vue-datatable"
                  :data-manager="DataManager"
                  ref="datatable">
            <template slot="ItemActions" scope="props">
                <div class="ItemActionsDiv">
                    <b-row no-gutters>
                        <b-col lg="6">
                            <font-awesome-icon :icon="['fa', 'edit']" style="font-size: 24px; margin-right:1rem;" class="pointer orange " @click="UpdateActionItemButton(props.rowData)" />
                        </b-col>
                        <b-col lg="6">
                            <ActionButtonWithIcon :requires-confirmation="true"
                                      confirmation-string="WARNING: You are about to delete this action item.  Are you sure?"
                                      endpoint="ChurchEngagement/ChartActivity/DeleteActionItem"
                                      :payload="{Id: props.rowData.Id}"
                                      :perform-global-update="false"
                                      button-variant="success"
                                      button-string=""
                                      button-size="md"
                                      emit-on-success="role-deleted"
                                      v-on:success="RefreshDataTable"
                                      icon-prefix="fa"
                                      icon-suffix="trash-alt"
                                      icon-color="red"
                                      method="POST"/>
                        </b-col>
                    </b-row>
                </div>
            </template>
            <template slot="EffectiveDueDate" scope="props">
                <div class="">
                    <div v-if="props.rowData.EffectiveDateTime">
                        <font-awesome-icon :icon="['fa', 'check-circle']" style="font-size: 24px;" class="pointer green" @click="EffectiveDueDateButton(props.rowData)" />
                    </div>
                    <div v-else>
                        <font-awesome-icon :icon="['fa', 'exclamation-circle']" style="font-size: 24px;" class="pointer red" @click="EffectiveDueDateButton(props.rowData)" />
                    </div>
                </div>
            </template>
        </vuetable>
        <!--ADD MODAL -->
        <span class="AddModal">
            <b-modal @show="ClearForm" @hidden="ClearForm" ref="component-modal" title="Create Action Item" hide-footer>
                <b-container fluid>
                    <b-form @submit="CreateActionItem">
                        <b-row>
                            <b-col cols="12"><b>Category:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <select class="form-control" v-model="form.category">
                                <option value="All">All</option>
                                <option v-for="ActionItemCategory in ActionItemCategories" :value="ActionItemCategory.value">{{ ActionItemCategory.text }}</option>
                            </select>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Description:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem"><b-form-textarea rows="3" v-model="form.narrative"></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Assignee:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <select class="form-control" v-model="form.assigneeUserID" required>
                                    <option v-for="assignee in AvailableAssignees" :value="assignee.value">{{ assignee.text }}</option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Due Date:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <flat-pickr class="form-control" v-model="form.dueDate" :config="DateConfig" required></flat-pickr>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="AddHide()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="primary" type="submit">
                                    CONFIRM
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>
        </span>

        <span class="UpdateModal">
            <b-modal ref="update-component-modal" title="Update Action Item" hide-footer>
                <b-container fluid>
                    <b-form @submit="UpdateActionItem">
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>Category:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <select class="form-control" v-model="updateForm.category">
                                <option value="All">All</option>
                                <option v-for="ActionItemCategory in ActionItemCategories" :value="ActionItemCategory.value">{{ ActionItemCategory.text }}</option>
                            </select>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>Description:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem"><b-form-textarea rows="3" v-model="updateForm.narrative"></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Assignee:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <select class="form-control" v-model="updateForm.assigneeUserID" required>
                                    <option v-for="assignee in AvailableAssignees" :value="assignee.value">{{ assignee.text }}</option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Due Date:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <flat-pickr class="form-control" v-model="updateForm.dueDate" :config="DateConfig" required></flat-pickr>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="EditHide()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="primary" type="submit">
                                    CONFIRM
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>
        </span>
        <span class="EffectiveDueDateModal">
            <b-modal ref="effective-due-date-component-modal" title="Complete Action Item" hide-footer>
                <b-container fluid>
                    <b-form @submit="CompleteActionItem">
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>Completed on:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <flat-pickr class="form-control" v-model="updateForm.effectiveDateTime" :config="DateConfig"></flat-pickr>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="EffectiveDueDateHide()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="primary" type="submit">
                                    CONFIRM
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>
        </span>
    </div>
</template>

<script>
    //import components
    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    // import helper functions
    import ActionButtonWithIcon from '../../../Admin/ActionButtonWithIcon.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
    library.add(faCheckCircle);
    import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
    library.add(faExclamationCircle);

    import { EventBus } from '../../../../services/event-bus.js';

    export default {
        name: "ActionItem",
        created() {
            let vm = this;
            EventBus.$on('chart-activity-updated', val => {
                if (val == vm.ChurchRecordData.Church.Id) {
                    vm.GetActionItems();
                }
            });
        },
        beforeDestroy() {
            EventBus.$off('chart-activity-updated');
        },
        props: [
            'ChurchRecordData'
        ],
        data: function () {
            return {
                ActionItemsList: [],
                form: {
                    Id: '',
                    category: '',
                    narrative: '',
                    dueDate: '',
                    assigneeUserID: '',
                    authorUserID: '',
                    effectiveDueDate: ''
                },
                updateForm: {
                    Id: '',
                    category: '',
                    narrative: '',
                    dueDate: '',
                    effectiveDateTime: '',
                    assigneeUserID: '',
                },
                DateConfig: {
                    dateFormat: 'm/d/Y',
                    allowInput: true,
                    required: false
                },
                TableSearch: "",
                Filters: {
                    DueDateTime: moment().add(-2, 'months').format('YYYY-MM-DD'),
                    EndDueDateTime: "",
                    Category: "All"
                },
                ActionItemTable: {
                    Fields: [
                        {
                            name: 'DueDateTime',
                            title: 'Due Date',
                            callback: 'formatDateOptionalTime|MM/DD/YY',
                            sortField: 'DueDateTime'
                        },
                        {
                            name: 'Category',
                            title: 'Category',
                            sortField: 'Category'
                        },
                        {
                            name: 'Narrative',
                            title: 'Description',
                            sortField: 'Narrative'
                        },
                        {
                            name: 'AssigneeUser.UserName',
                            title: 'Assignee',
                            sortField: 'AssigneeUser.UserName'
                        },
                        {
                            name: '__slot:EffectiveDueDate',
                            title: 'Completed',
                            sortField: 'Index'
                        },
                        {
                            name: '__slot:ItemActions',
                            title: 'Action'
                        }
                    ]
                }
            };
        },
        methods: {
            EffectiveDueDateButton(rowData) {
                this.updateForm.Id = rowData.Id;
                this.updateForm.category = rowData.Category;
                this.updateForm.narrative = rowData.Narrative;
                this.updateForm.dueDate = this.formatDate(rowData.DueDateTime);
                this.updateForm.assigneeUserID = rowData.AssigneeUserID;
                this.updateForm.effectiveDateTime = this.formatDate(rowData.EffectiveDateTime);
                this.$refs['effective-due-date-component-modal'].show();
            },
            AddHide() {
                this.$refs['component-modal'].hide();
            },
            EffectiveDueDateHide() {
                this.$refs['effective-due-date-component-modal'].hide();
            },
            EditHide() {
                this.$refs['update-component-modal'].hide();
            },
            UpdateActionItemButton(rowData) {
                this.updateForm.Id = rowData.Id;
                this.updateForm.category = rowData.Category;
                this.updateForm.narrative = rowData.Narrative;
                this.updateForm.dueDate = this.formatDate(rowData.DueDateTime);
                this.updateForm.assigneeUserID = rowData.AssigneeUserID;
                this.updateForm.effectiveDateTime = this.formatDate(rowData.EffectiveDateTime);
                this.$refs['update-component-modal'].show();
            },

            ShowAddModal() {
                this.form.Id = this.ChurchRecordData.Church.Id;
                this.form.category = '';
                this.form.narrative = '';
                this.form.dueDate = '';
                this.form.assigneeUserID = '';
                this.form.authorUserID = '';
                this.$refs['component-modal'].show();
            },
            CompleteActionItemButton() {
                this.$refs['complete-action-item-component-modal'].show();
            },
            RefreshDataTable() {
                this.GetActionItems();
            },
            CreateActionItem(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "ChurchEngagement/ChartActivity/CreateActionItem",
                    {
                        ChurchID: this.ChurchRecordData.Church.Id,
                        Category: this.form.category,
                        EffectiveDateTime: this.form.EffectiveDateTime,
                        DueDateTime: this.form.dueDate,
                        AssigneeUserID: this.form.assigneeUserID,
                        AuthorUserID: this.form.authorUserID,
                        Narrative: this.form.narrative
                    }, this.CreateActionItemSuccess, () => { }, false);
            },
            CreateActionItemSuccess(response) {
                EventBus.$emit('chart-activity-updated', this.ChurchRecordData.Church.Id);
                this.$refs['component-modal'].hide();
            },
            GetActionItems() {
                  this.$MasterAPI.ExecuteRequest("GET", "ChurchEngagement/ChartActivity/GetActionItems",
                    {
                        DueDateTime: this.Filters.DueDateTime,
                        EndDueDateTime: this.Filters.EndDueDateTime,
                        Category: this.Filters.Category,
                        ChurchID: this.ChurchRecordData.Church.Id
                    }, this.GetActionItemsSuccess, () => { }, false);
            },
            GetActionItemsSuccess(response) {
                this.ActionItemsList = response.data.data;
                for (var i = 0; i < this.ActionItemsList.length; i++) {
                    if (this.ActionItemsList[i].EffectiveDateTime === null)
                        this.ActionItemsList[i].Index = 0;
                    else
                        this.ActionItemsList[i].Index = 1;
                }
                this.$refs.datatable.refresh();
            },
            UpdateActionItem(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "ChurchEngagement/ChartActivity/UpdateActionItem",
                    {
                        ChurchID: this.updateForm.Id,
                        Category: this.updateForm.category,
                        EffectiveDateTime: this.updateForm.effectiveDateTime,
                        DueDateTime: this.updateForm.dueDate,
                        AssigneeUserID: this.updateForm.assigneeUserID,
                        Narrative: this.updateForm.narrative
                    }, this.UpdateActionItemSuccess, () => { }, false);
            },
            UpdateActionItemSuccess(response) {
                EventBus.$emit('chart-activity-updated', this.ChurchRecordData.Church.Id);
                this.EditHide();
            },
            CompleteActionItem(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "ChurchEngagement/ChartActivity/CompleteActionItem",
                    {
                        ChartActivitiesID: this.updateForm.Id,
                        EffectiveDateTime: this.updateForm.effectiveDateTime
                    }, this.CompleteActionItemSuccess, () => { }, false);
            },
            CompleteActionItemSuccess(response) {
                EventBus.$emit('chart-activity-updated', this.ChurchRecordData.Church.Id);
                this.EffectiveDueDateHide();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.ActionItemsList;
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }

                } else {
                    return [];
                }
            },
            formatDateOptionalTime(value, dflt) {
                if (value == null) {
                    return dflt;
                }
                let initialValue = moment(value, 'YYYY-MM-DD HH:mm:ss');
                if (initialValue.hours() == 0 && initialValue.minutes() == 0) {
                    return initialValue.format('MM/DD/YYYY');
                } else {
                    return initialValue.format('MM/DD/YYYY h:mm A');
                }
            },
            formatDate(value) {
                if (value == null || value == '') {
                    return null;
                } else {
                    return moment(value, 'YYYY-MM-DD').format("MM/DD/YYYY");
                }
            }
        },
        components: {
            Vuetable,
            ActionButtonWithIcon,
            flatPickr
        },
        computed: {
            AvailableAssignees: function () {
                let vm = this;
                let employees = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramEmployees"](this.ChurchRecordData.SubProgramMembership.SubProgram.Id).filter(e => e.IsFamilyCaseCarrier == true);
                let employeeOptions = [];
                employees.forEach(function (item) {
                    employeeOptions.push({
                        text: item.Employee.Person.FullName,
                        value: item.Employee.ApplicationUserID,
                    });
                });
                
                return employeeOptions;
            },
            ActionItemCategories: function () {
                return this.$store.state.Options.ChurchEngagement.CEActivityOptions;
            },
            PlacementOptions: function () {
                let options = [];
                this.AvailablePlacements.forEach(function (item) {
                    options.push({
                        text: item.FosterResourceFamilyName,
                        value: item.FosterResourceFamilyID
                    });
                });
                return options;
            }
        },
        mounted() {
            var vm = this;
            this.GetActionItems();
            let getActionItemsFunc = function () {
                vm.GetActionItems();
            };
            this.$GlobalUpdate.AddGlobalUpdateFunction(getActionItemsFunc);
        }
    }
</script>

<style scoped>
    .vue-datatable {
        width: 100%;
        display: inline-block;
        overflow-x: auto;
    }
</style>